<template>
  <div>

    <v-alert
      prominent
      type="warning"
      icon="mdi-map-marker-question-outline"
      v-if="isAdmin"
    >
      <v-row align="center">
        <v-col class="grow">
          {{ $t("forms.info.warningDirectEdit") }}
        </v-col>
        <v-col class="shrink">
          <v-btn
            to="/manage/edit/projects"
          >
            <v-icon
              left
              dark
            >
              mdi-arrow-right-circle
            </v-icon>
            {{ $t("forms.info.gotoDirectEdit") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <PendingUserForms
      v-if="pendingForms.length"
      :title="$t('table.project.pendingForms')"
      :items="pendingForms"
    />

    <v-card class="mt-4">
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item-group>
            <v-row no-gutters>
              <v-col
                v-for="(form, index) in forms"
                :key="index"
                cols="12"
                md="6"
                lg="4"
                class="text-left"
              >
                <v-list-item :to="form.path">
                  <v-list-item-icon>
                    <v-icon v-text="form.icon"></v-icon>
                  </v-list-item-icon>
                  {{ $t(form.title) }}
                </v-list-item>
              </v-col>
            </v-row>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="projects"
      :search="search"
      class="elevation-1 table-cursor-hand mt-4"
      :items-per-page="15"
      :custom-filter="filterItems"
      :footer-props="{
        itemsPerPageOptions: [15, 30, -1],
        itemsPerPageText: $t('table.itemsPerPageText')
      }"
      sort-by="title[es]"
      @click:row="clickRow"
      :loading="loading"
      :loading-text="$t('table.loading')"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.title="{ item }">
        <span
          v-if="item.title['gl'] !== '' && item.title['gl'] !== undefined"
          >{{ item.title["gl"] }}</span
        >
        <span
          v-else-if="item.title['es'] !== '' && item.title['es'] !== undefined"
          >{{ item.title["es"] }}</span
        >
        <span v-else>{{ item.title["en"] }}</span>
      </template>
      <template v-slot:item.type="{ item }">
        {{ $t("project.types." + item.type) }}
      </template>
      <template v-slot:item.external="{ item }">
        <v-icon class="ml-6" v-if="item.external" color="green">
          mdi-check-circle
        </v-icon>
        <v-icon v-else class="ml-6" color="red">
          mdi-close-circle
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import PendingUserForms from "../forms/PendingUserForms";
export default {
  components: { PendingUserForms },
  data: () => ({
    pendingForms: [{}],
    loading: true,
    search: "",
    projects: [],
    forms: [
      {
        icon: "mdi-plus",
        title: "project.forms.newProject",
        path: "/my-forms/project/newProject"
      }
    ]
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t("form.title"),
          value: "title"
        },
        { text: this.$t("table.acronym"), value: "acronym" },
        {
          text: this.$t("table.type"),
          value: "type"
        },
        {
          text: this.$t("table.external_project"),
          value: "external"
        },
        {
          text: this.$t("form.project.start_date"),
          value: "start_date"
        }
      ];
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/user/project";
      axios
        .get(path)
        .then(response => {
          this.projects = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });

      path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/pending/project";
      axios
        .get(path)
        .then(response => {
          this.pendingForms = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    filterItems(value, search, item) {
      const search_value = search
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      let customValue = "";
      if (item.title["gl"] !== "" && item.title["gl"] !== undefined) {
        customValue = item.title["gl"];
      } else if (item.title["es"] !== "" && item.title["es"] !== undefined) {
        customValue = item.title["es"];
      } else {
        customValue = item.title["en"];
      }

      customValue = customValue
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return (
        customValue != null &&
        search_value != null &&
        typeof customValue === "string" &&
        customValue.indexOf(search_value) !== -1
      );
    },

    clickRow(item) {
      this.$router.push({ path: `/projects/${item.id}` });
    }
  }
};
</script>
